<!-- Status de Conexão -->
<div class="pwa-status" [class]="statusClass()">
  <i [class]="statusIcon()"></i>
  <span class="status-text">{{ statusText() }}</span>
</div>
